<template>
    <b-card show-header
            show-footer
            class="w-100"
            v-bind:class="{ sent: isSent, received: !isSent && isReceived }">
            <div slot="footer" class="row text-muted">
                <div class="col footer">
                    <span>Skapades
                        <span class="datetime" v-b-tooltip :title="createdTimeFull">{{ createdTime }}</span> 
                        <span v-if="updatedTime !== 'Aldrig'">
                            <span v-if="deadline === 'Aldrig'">och </span><span v-else>, </span>uppdaterades
                            <span class="datetime" v-b-tooltip :title="updatedTimeFull">{{ updatedTime }}</span>
                        </span>
                        <span v-if="deadline !== 'Aldrig'">
                            och förfaller
                            <span v-b-tooltip :title="deadlineFull" class="datetime">{{ deadline }}</span>
                        </span>
                    </span>
                </div>
            </div>
            <div slot="header" class="row">
                <div class="col-sm">
                    <b-nav class="task-header" pills>
                        <b-nav-item>@{{ this.creator.username }}</b-nav-item>
                        <b-nav-item-dropdown v-if="showStatusDropdown" :text="statusString" size="sm">
                            <b-dropdown-item v-on:click="setStatus(1)">Öppen</b-dropdown-item>
                            <b-dropdown-item v-on:click="setStatus(6)">Klar</b-dropdown-item>
                            <b-dropdown-item v-on:click="setStatus(3)">Planerad</b-dropdown-item>
                            <b-dropdown-item v-on:click="setStatus(4)">Pågående</b-dropdown-item>
                            <b-dropdown-item v-on:click="setStatus(5)">Avvakta</b-dropdown-item>
                            <b-dropdown-item v-on:click="setStatus(2)">Avslutad</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item v-if="showStatusInformation">{{ status }}</b-nav-item>
                        <b-nav-item-dropdown v-if="showSharedStatusDropdown" :text="sharedStatus" size="sm">
                            <b-dropdown-item v-on:click="setSharedStatus(6)">Klar</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item-dropdown v-if="showSharedDropdown" :text="sharedStatus" size="sm">
                            <b-dropdown-item v-on:click="setSharedStatus(4)">Acceptera</b-dropdown-item>
                            <b-dropdown-item v-on:click="setSharedStatus(5)">Neka</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item v-if="showSharedStatus && !showSharedDropdown && !showSharedStatusDropdown">{{ sharedStatus }}</b-nav-item>
                        <b-nav-item size="sm" class="workname align-items-center" v-if="getWorkarea !== ''">{{ getWorkarea }}</b-nav-item>
                        <b-nav-item size="sm" class="workname" v-else>Ingen</b-nav-item>
                        <b-nav-item class="unread ml-auto" v-if="unreadMessages > 0">
                            <b-badge pill variant="danger">{{ unreadMessages }}</b-badge>
                        </b-nav-item>
                        <b-nav-item class="unread-recv ml-auto" v-if="unreadMessagesOutgoing > 0">
                            <b-badge pill variant="primary">{{ unreadMessagesOutgoing }}</b-badge>
                        </b-nav-item>
                        <b-nav-item v-bind:class="{'ml-auto': (unreadMessages === 0 && unreadMessagesOutgoing === 0)}" size="sm">
                            <b-button variant="success" v-on:click="$emit('send')" size="sm"><i class="material-icons icon">&#xE154;</i></b-button>
                        </b-nav-item>
                        <b-nav-item size="sm">
                            <b-button class="favorite" v-bind:class="{favorited: isFavorited}" @click="toggleFavorited()" size="sm">
                                <i v-if="isFavorited" class="material-icons icon">&#xE838;</i>
                                <i v-else class="material-icons icon">&#xE83A;</i>
                            </b-button>
                        </b-nav-item>
                        <b-nav-item size="sm" v-if="showRemove">
                            <b-button variant="danger" v-on:click="$emit('remove')" size="sm"><i class="material-icons icon">&#xE872;</i></b-button>
                        </b-nav-item>
                    </b-nav>
                </div>
            </div>
            <router-link active-class="active" :to="{ name: 'Task', params: { id: task.id } }" exact>
                <a v-html="task.content_parsed"></a>
            </router-link>
    </b-card>
</template>

<script>
import _ from 'lodash'
import helper from '@/utils/helper'
import { mapActions } from 'vuex'
import marked from 'marked'

marked.setOptions({
    sanitize: true,
    gfm: true,
    breaks: true
})

export default {
    name: 'Task',
    props: {
        task: {
            type: Object,
            required: true
        },
        workarea: {
            type: Object,
            required: false
        },
        index: {
            type: Number,
            required: false
        }
    },
    data () {
        return {
        }
    },
    computed: {
        favorites () {
            return this.$store.state.favorites.favorites
        },
        currentWorkarea () {
            if (this.workarea !== undefined && this.workarea !== null) {
                return this.workarea
            } else {
                return 'Ingen'
            }
        },
        isSent () {
            return helper.task.isSent(this.task, this.$store.state.authentication.user, this.currentWorkarea)
        },
        isReceived () {
            return helper.task.isReceived(this.task, this.$store.state.authentication.user, this.currentWorkarea)
        },
        createdTime () {
            return helper.task.getCreatedTime(this.task)
        },
        updatedTime () {
            return helper.task.getUpdatedTime(this.task)
        },
        createdTimeFull () {
            return helper.task.getCreatedTimeFull(this.task)
        },
        updatedTimeFull () {
            return helper.task.getUpdatedTimeFull(this.task)
        },
        deadline () {
            return helper.task.formatTime(this.task.deadline)
        },
        deadlineFull () {
            return helper.task.formatTimeFull(this.task.deadline)
        },
        creator () {
            return helper.task.getCreator(this.task)
        },
        status () {
            return this.task.status
        },
        statusString () {
            return helper.status.toString(this.status)
        },
        sharedStatus () {
            var status = 10
            var highest = 0

            // If we are a receiver on the task we are only interested in our own status
            if (this.task.creator !== this.$store.state.authentication.user.id) {
                let user = _.find(this.task.users, {user: this.$store.state.authentication.user.id})

                if (user !== undefined && user !== null) {
                    return helper.sharedStatus.toString(user.shared_status)
                }
            }

            _.each(this.task.users, user => {
                // Find the lowest status that is not from the creator
                if (user.shared_status < status && user.user !== this.task.creator && user.shared_status !== this.task.shared_status) {
                    status = user.shared_status
                }

                if (user.shared_status > highest && user.user !== this.task.creator && user.shared_status !== this.task.shared_status) {
                    highest = user.shared_status
                }
            })

            // Don't show rejected if everyone else is done
            if (status === 5 && highest > status && highest < 8) {
                status = highest
            }

            // Check if we didn't find any new status
            if (status === 10) {
                status = this.task.shared_status
            }

            return helper.sharedStatus.toString(status)
        },
        isFavorited () {
            return _.includes(this.favorites, this.task.id)
        },
        isCreator () {
            return this.$store.state.authentication.user.id === this.task.creator
        },
        isMember () {
            return _.find(this.task.users, {user: this.$store.state.authentication.user.id}) !== undefined
        },
        isWorkarea () {
            return _.find(this.$store.state.workarea.workareas, {id: this.task.workarea}) !== undefined
        },
        isShared () {
            return this.task.users.length > 1
        },
        isWorkspaceReceived () {
            let workspace = _.find(this.$store.state.workarea.workareas, {id: this.task.workarea})

            if (workspace !== null && workspace !== undefined && this.task.users.length > 1) {
                return _.find(workspace.members, {id: this.task.creator}) === undefined
            }

            return false
        },
        showSharedDropdown () {
            return (((this.isShared && this.isMember && !this.isCreator) || this.isWorkspaceReceived) && this.canAccept)
        },
        showSharedStatus () {
            return (this.isShared && (this.isCreator || this.isWorkarea) && !this.isWorkspaceReceived)
        },
        showStatusDropdown () {
            return (this.isCreator || this.isWorkarea) && !this.isWorkspaceReceived
        },
        showSharedStatusDropdown () {
            return (((this.isShared && this.isMember && !this.isCreator) || this.isWorkspaceReceived) && !this.canAccept)
        },
        showStatusInformation () {
            return (!this.isCreator && !this.isMember && !this.isWorkarea)
        },
        showRemove () {
            return (this.isCreator || this.isWorkarea) && this.creatorIsWorkspaceMember
        },
        creatorIsWorkspaceMember () {
            let workspace = _.find(this.$store.state.workarea.workareas, {id: this.task.workarea})

            if (workspace !== null && workspace !== undefined && this.task.users.length > 1) {
                return _.find(workspace.members, {id: this.task.creator}) !== undefined
            }

            return true
        },
        unreadMessages () {
            if (this.task.messages) {
                let user = this.$store.state.authentication.user
                let workareas = this.$store.state.workarea.workareas
                return _.filter(this.task.messages, message => (message.acknowledged_by === null || message.acknowledged_by === undefined) && helper.task.isIncommingMessage(this.task, user, message, workareas)).length
            } else {
                return 0
            }
        },
        unreadMessagesOutgoing () {
            if (this.task.messages) {
                let user = this.$store.state.authentication.user
                let workareas = this.$store.state.workarea.workareas
                return _.filter(this.task.messages, message => (message.acknowledged_by === null || message.acknowledged_by === undefined) && !helper.task.isIncommingMessage(this.task, user, message, workareas)).length
            } else {
                return 0
            }
        },
        canAccept () {
            if (this.task.workarea !== null && this.task.workarea !== undefined) {
                let workarea = _.find(this.$store.state.workarea.workareas, {id: this.task.workarea})
                let user

                if (!workarea) {
                    console.log('COULD NOT FIND WORKAREA', this.task.workarea, this.task)
                }

                _.each(workarea.members, member => {
                    if (user === undefined || user === null) {
                        user = _.find(this.task.users, {user: member.id})
                    }
                })

                if (user !== undefined && user !== null) {
                    return (user.shared_status < 4)
                }
            }

            if (this.task.shared_status < 4) {
                return true
            }

            return false
        },
        getWorkarea () {
            let workspace = _.find(this.$store.state.workarea.workareas, {id: this.task.workarea})

            if (workspace !== null && workspace !== undefined) {
                return workspace.name
            }

            return ''
        }
    },
    methods: {
        ...mapActions({
            setStatusStore: 'task_status',
            setSharedStatusStore: 'task_shared_status',
            addFavorite: 'favorites_insert',
            delFavorite: 'favorites_remove'
        }),
        setStatus: function (status) {
            this.setStatusStore({task: this.task, status})
        },
        setSharedStatus: function (status) {
            if (status === 6) {
                this.setStatusStore({task: this.task, status: 6})
            }

            if (status === 7 || status === 5) {
                this.setStatusStore({task: this.task, status: 2})
            }

            this.setSharedStatusStore({task: this.task, status})
        },
        getStatus: function () {
            return helper.status.toString(this.status)
        },
        toggleFavorited: function () {
            if (this.isFavorited) {
                this.delFavorite(this.task)
            } else {
                this.addFavorite(this.task)
            }
        },
        marked: function (content) {
            return marked(content)
        }
    }
}
</script>

<style lang="scss">
    .sent .card-header .task-header .dropdown .dropdown-menu a {
        color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/Task.vue